import { render, staticRenderFns } from "./btn-submit.vue?vue&type=template&id=2b04de68&"
import script from "./btn-submit.vue?vue&type=script&lang=js&"
export * from "./btn-submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports